module.exports = __webpack_public_path__ + "img/issus.335bdbee.png";